/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMultiplier1x = createReactComponent("multiplier-1x", "IconMultiplier1x", [
  ["path", { d: "M9 16v-8l-2 2", key: "svg-0" }],
  ["path", { d: "M13 16l4 -4", key: "svg-1" }],
  ["path", { d: "M17 16l-4 -4", key: "svg-2" }]
]);

export { IconMultiplier1x as default };
//# sourceMappingURL=IconMultiplier1x.js.map
